<template>
  <partner-layout @scrolled-to-bottom="handleScrolledToBottom">
    <template #default>
      <main-title>Мои проекты</main-title>
      <horizontal-filter>
        <template #default>
          <filter-item path="/partner/requests" text="Запросы" />
          <filter-item path="/partner/projects" text="Мои проекты" />
        </template>
        <template #right>
          <label class="panel__total-items" v-if="totalItems">
            Всего: {{ totalItems }}
          </label>
          <switch-view-buttons />
        </template>
      </horizontal-filter>
      <request-filter @update-filter="updateFilter" />
      <infinite-grid-layout
        :get-items="api.request.index"
        :url-params="urlParams"
        :scroll-bottom="scrollBottom"
        :one-column="currentView === '#table'"
        entity="requests"
        @update-total-count="handleUpdateTotalCount"
      >
        <template #table-header v-if="currentView === '#table'">
          <partner-request-table-header />
        </template>
        <template #table-item="slotProps">
          <router-link :to="getLink(slotProps.item)">
            <partner-request-table-item
              v-if="currentView === '#table'"
              :request="slotProps.item"
            />
            <request-card v-else :request="slotProps.item" />
          </router-link>
        </template>
      </infinite-grid-layout>
    </template>
  </partner-layout>
</template>

<script setup>
  import { computed, onMounted, ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import PartnerLayout from '@/layouts/PartnerLayout';
  import MainTitle from '@/components/titles/MainTitle';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter';
  import FilterItem from '@/components/filter/components/FilterItem';
  import SwitchViewButtons from '@/components/switch-view/SwitchViewButtons';
  import RequestCard from '@/components/requests/components/RequestCard.vue';
  import InfiniteGridLayout from '@/components/infinite-grid/InfiniteGridLayout.vue';
  import PartnerRequestTableHeader from '@/views/partner/requests/components/PartnerRequestTableHeader.vue';
  import PartnerRequestTableItem from '@/views/partner/requests/components/PartnerRequestTableItem.vue';
  import RequestFilter from '@/components/requests/components/RequestFilter.vue';

  const route = useRoute();
  const api = useApi();
  const currentView = computed(() => route.hash);
  const urlParams = ref(null);
  const totalItems = ref(0);
  const scrollBottom = ref(0);

  onMounted(() => {
    urlParams.value = new URLSearchParams({
      role: route.meta.role,
      sort: '-id',
    });
    if (route.query.textSearch) {
      urlParams.value.set('textSearch', route.query.textSearch);
    }
  });

  watch(
    () => route.hash,
    async () => {
      updateFilter(new URLSearchParams([...urlParams.value]));
    }
  );

  const updateFilter = (filterParams) => {
    urlParams.value = filterParams;
  };

  const handleScrolledToBottom = (value) => {
    scrollBottom.value = value;
  };

  const handleUpdateTotalCount = (value) => {
    totalItems.value = value;
  };

  const getLink = (request) => {
    return `/partner/requests/${request.id}`;
  };
</script>

<style lang="scss" scoped>
  .panel__total-items {
    align-self: center;
  }
</style>
